import styles from "./Accordion.module.scss";

export default function Accordion({ children }) {
  /* To use, insert any content into a nested 
  <Accordion>
    <AccordionItem> {content} </AccordionItem> 
  </Accordion>
  */

  return (
    <div className={`${styles.accordionWrapper}`}>
      <div className={`${styles.accordionList}`}>{children}</div>
    </div>
  );
}
